// extracted by mini-css-extract-plugin
export default {"shiftsTable":"O25gJqLpAackgmJNPzeS","rowNumberColumn":"U8Vg7Q6H5z9lLFPL_YuE","actionsColumn":"sWAbHL9aRdvYD2gGWd6C"};